module.exports = __webpack_public_path__ + "officialStatic/img/smallImg37.bf10cd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/smallImg37.png
// module id = HfmH
// module chunks = 0